/**
 * Template strings that are used to inject dynamic values for variables by
 * doing string replacement.
 *
 * It was tempting to declare this as a const enum, so that the TypeScript
 * compiler would inline the values, and we could use it in extendscript code.
 *
 * However, such const enums are not allowed to be used accross project
 * boundaries when the "isolatedModules" typescript option is enabled.
 *
 * And even if we didn't use "isolatedModules" for the way we bundle
 * extendscript code, we're also using this enum from non-extendscript code
 * which definitely want to use the "isolatedModules" option.
 */
export enum EncoderScriptTemplates {
  SCRIPT_SOURCE_PATH_TEMPLATE = '<script_source>',
  SCRIPT_PRESET_PATH_TEMPLATE = '<preset_path>',
  SCRIPT_DESTINATION_PATH_TEMPLATE = '<destination_path>',
  SCRIPT_PROGRESS_PATH_TEMPLATE = '<progress_path>',
  ENCODER_EXE_PATH_TEMPLATE = '<encoder_exe_path>',
  ITEM_ID_TEMPLATE = '<item_id>',
}

export type EncoderJobStatus = 'starting' | 'audioProgress' | 'progress' | 'complete' | 'failed' | 'retryableFailure';

export interface ProgressInfo {
  itemId: string;
  status: EncoderJobStatus;
  progress?: number;
  log: string;
}
